export default "__VITE_ASSET__fG5ilFTX__"